import { IonContent, IonPage, IonHeader } from '@ionic/react'
import AdminHeader from '../../components/header/admin-header'
import AccountAnalytics from '../../analytics/components/account-analytics'

function AccountAnalyticsPage() {
  return (
    <IonPage>
      <IonHeader>
        <AdminHeader showMenu title="Loyalty Analytics" />
      </IonHeader>
      <IonContent>
        <AccountAnalytics id="ca8c2059-78bc-4191-8c18-1b4e75a89093" />
      </IonContent>
    </IonPage>
  )
}

export default AccountAnalyticsPage
